import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../components/CashbackInterceptor/components/Container.js';
import { Highlight } from '../../components/CashbackInterceptor/components/Highlight.js';
import { CashbackInterceptorSize } from '../../components/CashbackInterceptor/models.js';
import { NoWrap } from '../../primitives/index.js';
export const CashbackInterceptor = ({
  size = CashbackInterceptorSize.INLINE,
  inverted = false,
  text,
  highlight,
  ...restProps
}) => {
  if (!highlight || !text) {
    return null;
  }
  return _jsxs(Container, {
    ...restProps,
    as: "strong",
    size: size,
    inverted: inverted,
    children: [_jsx(NoWrap, {
      children: text
    }), _jsx(Highlight, {
      size: size,
      inverted: inverted,
      children: _jsx(NoWrap, {
        children: highlight
      })
    })]
  });
};